export enum TPuntEvents {
  BACK = 'BACK',
  PUNT_SELECTED = 'PUNT_SELECTED',
  FAKE_SELECTED = 'FAKE_SELECTED',
  ON_FUMBLE = 'ON_FUMBLE',
  TO_START = 'TO_START',
  ON_REF = 'ON_REF',
  TO_CONFIRMATION = 'TO_CONFIRMATION',
  TO_YARDAGE = 'TO_YARDAGE',
  BACK_TO_FUMBLE_RECOVERY = 'BACK_TO_FUMBLE_RECOVERY',
  CONFIRMED = 'CONFIRMED',
  BACK_TO_PUNT_RESULT = 'BACK_TO_PUNT_RESULT',
  PENALTY_SELECTED = 'PENALTY_SELECTED',
  POSSESSION_SELECTED = 'POSSESSION_SELECTED',
  BACK_TO_SELECT_POSSESSION = 'BACK_TO_SELECT_POSSESSION',
}

export enum TPuntStates {
  PUNT_TYPE = 'PUNT_TYPE',
  PUNT_RESULT = 'PUNT_RESULT',
  SELECT_YARDAGE = 'SELECT_YARDAGE',
  REF_EVENT = 'REF_EVENT',
  SELECT_REF_TYPE = 'SELECT_REF_TYPE',
  CONFIRMATION = 'CONFIRMATION',
  FUMBLE = 'FUMBLE',
  REF_EVT = 'REF_EVT',
  HANDLE_YARDAGE_TOGGLES = 'HANDLE_YARDAGE_TOGGLES',
  SELECT_POSSESSION = 'SELECT_POSSESSION',
  SELECT_DOWN_POST_PENALTY = 'SELECT_DOWN_POST_PENALTY',
}
